export default theme => ({
    tabsWrapper: {
        backgroundColor: '#fff',
        width: '100%',
        position: 'relative'
    },
    tab: {
        top: -1,
        flexDirection: 'row',
        whiteSpace: 'nowrap',
        textTransform: 'none',
        color: theme.palette.grey[500],
        fontSize: 14,
        padding: '14px 35px',
        letterSpacing: '0.2px',
        fontWeight: 700,
        opacity: 1,
        minWidth: 'auto',
        borderRight: `1px solid ${theme.palette.grey[300]}`,
        '&:last-child': {
            boxShadow: `5px 0px 10px 3px ${theme.palette.grey[200]}`
        },
        '&:not(.Mui-selected):hover': {
            color: theme.palette.grey[600]
        },
        '&.Mui-selected': {
            padding: '13px 30px 15px',
            top: 1,
            color: theme.palette.grey[900],
            '&:after': {
                content: '""',
                position: 'absolute',
                width: '100%',
                backgroundColor: '#fff',
                left: 0,
                bottom: 1,
                height: 2,
                zIndex: 100,
                pointerEvents: 'none'
            }
        },
        '& > svg': {
            marginRight: 5
        },
        '& > div': {
            maxWidth: 250,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    },
    flexContainer: {
        '&:after': {
            content: '""',
            position: 'absolute',
            width: '100%',
            backgroundColor: theme.palette.grey[300],
            left: 0,
            bottom: 0,
            height: 1,
            pointerEvents: 'none'
        }
    },
    indicator: {
        display: 'none'
    },
    closeIcon: {
        position: 'absolute',
        top: 10,
        right: 7
    },
    scrollButtons: {
        position: 'absolute',
        top: 10,
        width: 30,
        height: 30,
        borderRadius: '50%',
        zIndex: 100,
        color: '#fff',
        backgroundColor: theme.palette.grey[300],
        '&:first-child': {
            left: 5
        },
        '&:last-child': {
            right: 5
        }
    }
});
